import React from 'react';
import L from 'leaflet';
import 'esri-leaflet'
import * as ELG from 'esri-leaflet-geocoder';
import { Map, TileLayer } from 'react-leaflet'
import './index.css'

class ShareMapComponent extends React.Component {
  componentDidMount() {
    const map = this.refs.map.leafletElement;
    const searchControl = new ELG.Geosearch().addTo(map);
    const results = new L.LayerGroup().addTo(map);

    searchControl.on('results', (data) => {
      results.clearLayers();
      for (let i = data.results.length - 1; i >= 0; i--) {
        results.addLayer(L.marker(data.results[i].latlng));
        const latlng = data.results[i].latlng;
        this.props.changeLoc(latlng)
        break;
      }
    })

    map.on('click', (e) => {
      results.clearLayers();
      results.addLayer(L.marker(e.latlng))
      this.props.changeLoc(e.latlng)
    });


    setTimeout(() => { map.invalidateSize() }, 0); // fix map displaing
  }

  render() {
    return (
      <Map
        ref='map'
        center={[52.13, 21.02]} // Warsaw, PL
        zoom={5}
      >

        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url='https://{s}.tile.osm.org/{z}/{x}/{y}.png'
        />
      </Map>
    )
  }
}

export default ShareMapComponent;